export enum LinkUserResult {
    Successful = 1,
    AlreadyLinked,
    SameUser,
    UserNotFound
}
